import { render, staticRenderFns } from "./playerprofile.vue?vue&type=template&id=7cf8f746"
import script from "./playerprofile.vue?vue&type=script&lang=js"
export * from "./playerprofile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports